<div class="audit-trail-view-box modal-body" (mouseleave)="dialogOut()">
    <span class="modal-results-hover" [ngClass]="hasAdjustment ? 'show-comment-with-adj':'not-show-comment'">Click to add a description for this adjustment <br/></span>
    <span class="adjustment-result"><b>&nbsp;{{getRoundedTauValue(skuData.tauValueFromStep2)}}  Original Tau </b> -
        {{ lastUpdated }} </span>
    <span class="history" *ngFor="let log of tauAuditTrailLogs;index as i" [ngClass]="log.reasonForAdjustment ? 'has-desc-modal':'edit-result'"><b>{{i + 1}})</b>&nbsp;{{getRoundedTauValue(log.value)}}
        &nbsp;{{log.userName}} - {{log.lastUpdatedDate}}
        <br /><span class="reason-adj">{{log.reasonForAdjustment}}</span></span>
    <span class="describe-text">Use this space to document reasoning(s) behind modal <br/> adjustments.Click to add notes or delete</span>
</div>
